import { useI18n } from '../lib/i18n'
import { dismissMarkNotice, useMarkNotice } from '../lib/markNotice'

/** Tells the user once, when the first marked image opens, that images carry their mark (PRT-10). */
export function MarkNotice() {
  const { t } = useI18n()
  if (!useMarkNotice()) return null
  return (
    <div className="mark-notice" role="status">
      <p>{t('markNotice')}</p>
      <button type="button" onClick={dismissMarkNotice}>
        {t('markNoticeOk')}
      </button>
    </div>
  )
}
